import React from 'react';
import { Container } from 'reactstrap';
import ChangePasswordForm from '../../components/ChangePasswordForm/ChangePasswordForm';
import AccountSettingsNav from '../../components/AccountSettingsNav/AccountSettingsNav';

const ChangePassword = () => {
  return (
    <Container>
      <AccountSettingsNav />
      <ChangePasswordForm />
    </Container>
  );
};

export default ChangePassword;
